import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useGeoLanguage } from '../../lib/useGeoLanguage';
import { Globe } from 'lucide-react';
import './LanguageSelector.css';

export default function LanguageSelector() {
    const { t } = useTranslation();
    const { currentLanguage, changeLanguage, supportedLanguages } = useGeoLanguage();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const currentLangInfo = supportedLanguages.find(l => l.code === currentLanguage) || supportedLanguages[0];

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleSelect = (langCode: string) => {
        changeLanguage(langCode);
        setIsOpen(false);
    };

    return (
        <div className="language-selector" ref={dropdownRef}>
            <button 
                className="language-selector-trigger"
                onClick={() => setIsOpen(!isOpen)}
                aria-label={t('language.select')}
            >
                <Globe size={16} />
                <span className="current-lang-flag">{currentLangInfo.flag}</span>
                <span className="current-lang-code">{currentLanguage.toUpperCase()}</span>
            </button>

            {isOpen && (
                <div className="language-dropdown">
                    {supportedLanguages.map((lang) => (
                        <button
                            key={lang.code}
                            className={`language-option ${lang.code === currentLanguage ? 'active' : ''}`}
                            onClick={() => handleSelect(lang.code)}
                        >
                            <span className="lang-flag">{lang.flag}</span>
                            <span className="lang-name">{lang.name}</span>
                            <span className="lang-code">{lang.code.toUpperCase()}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}
